import dynamic from 'next/dynamic';
import React from 'react';

import {
  ProductPurchaseDetails,
  ProductPurchasingController,
} from '../../../types/Purchasing';

const GatedReleaseAccountCta = dynamic(
  () => import('./GatedReleaseAccountCta'),
  { ssr: false },
);

const GatedReleaseConnectWeb3WalletCta = dynamic(
  () => import('./GatedReleaseConnectWeb3WalletCta'),
  { ssr: false },
);

const GateRelease = dynamic(() => import('./GateRelease'), { ssr: false });

type Props<T extends ProductPurchaseDetails> = {
  product: ProductType;
  purchasingController: ProductPurchasingController<T>;
};

export const ProductGatedRelease = <T extends ProductPurchaseDetails>({
  children,
  product,
  purchasingController,
}: React.PropsWithChildren<Props<T>>) => {
  const { releaseGating } = purchasingController;

  if (releaseGating?.shouldGateReleaseNow()) {
    const productToGate = {
      ...product,
      timedReleaseClosingDate:
        product.releaseType === 'timed-release'
          ? purchasingController?.product?.closingDate
          : undefined,
    };

    return (
      <GatedReleaseAccountCta
        closingDate={purchasingController.product?.closingDate}
        product={productToGate}
      >
        <GatedReleaseConnectWeb3WalletCta
          closingDate={purchasingController.product?.closingDate}
          product={productToGate}
        >
          <GateRelease purchasingController={purchasingController}>
            {children}
          </GateRelease>
        </GatedReleaseConnectWeb3WalletCta>
      </GatedReleaseAccountCta>
    );
  }

  return <>{children}</>;
};
